/**
 * Logger que solo muestra mensajes en modo desarrollo.
 * Reemplazo directo de console.log/error/warn/info.
 * En producción (npm run build) no se muestra nada en consola.
 */
const isDev = process.env.NODE_ENV === 'development';

const logger = {
  log: (...args) => { if (isDev) console.log(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};

export default logger;
